export const canAccessWise = user => {
  if (!user) {
    return false;
  }
  if (user.type === 'SuperAdmin') {
    return true;
  }
  const permissions = user.permissions || {};
  const canUse =
    permissions.can_use_wise === true || permissions.can_see_wise === true;
  return canUse && Boolean(permissions.wise_user_id);
};
